import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['success', 'error']
  static values = { message: String }

  connect () {
    this.handler = (event) => this.show(event.detail?.message || 'Saved', event.detail?.variant || 'success')
    document.addEventListener('toast:show', this.handler)

    if (this.messageValue) this.show(this.messageValue, 'success')
  }

  disconnect () {
    document.removeEventListener('toast:show', this.handler)
  }

  show (message, variant) {
    const template = variant === 'error' ? this.errorTarget : this.successTarget
    const toast = template.content.firstElementChild.cloneNode(true)
    toast.querySelector('[data-toast-text]').textContent = message

    this.element.appendChild(toast)

    requestAnimationFrame(() => {
      toast.classList.remove('opacity-0', 'translate-y-2')
    })

    setTimeout(() => {
      toast.classList.add('opacity-0', 'translate-y-2')
      setTimeout(() => toast.remove(), 200)
    }, 3000)
  }
}
